module.exports = __webpack_public_path__ + "media/danger1.6870c03e.wav";